import { t9n } from './translate';
import { TS } from '../config/translation-keys.js';

export const init_zendesk = config => {
  window.CHAT = {
    messages: t9n('zendesk_messages'),
    tasks: t9n('zendesk_tasks'),
    mode: config.user.last_role,
    enterMessage: t9n('zendesk_please_enter'),
    noChats: t9n('zendesk_no_chats'),
    noMessages: t9n('zendesk_no_messages'),
    consumerUrl: window.location.origin,
  };

  window.zEmbed ||
    (function(e, t) {
      var n,
        o,
        d,
        i,
        s,
        a = [],
        r = document.createElement('iframe');
      (window.zEmbed = function() {
        a.push(arguments);
      }),
        (window.zE = window.zE || window.zEmbed),
        (r.src = 'javascript:false'),
        (r.title = ''),
        (r.role = 'presentation'),
        ((r.frameElement || r).style.cssText = 'display: none'),
        (d = document.getElementsByTagName('script')),
        (d = d[d.length - 1]),
        d.parentNode.insertBefore(r, d),
        (i = r.contentWindow),
        (s = i.document);
      try {
        o = s;
      } catch (e) {
        (n = document.domain),
          (r.src = 'javascript:var d=document.open();d.domain="' + n + '";void(0);'),
          (o = s);
      }
      (o.open()._l = function() {
        var e = this.createElement('script');
        n && (this.domain = n),
          (e.id = 'js-iframe-async'),
          (e.src = 'https://assets.zendesk.com/embeddable_framework/main.js'),
          (this.t = +new Date()),
          (this.zendeskHost = 'workpilots.zendesk.com'),
          (this.zEQueue = a),
          this.body.appendChild(e);
      }),
        o.write('<body onload="document._l();">'),
        o.close();
    })();

  zE(function() {
    zE.setHelpCenterSuggestions({ search: 'Pikaohje' });
    zE.setLocale(config.user.language);
    zE.identify({
      name: config.user.first_name + ' ' + config.user.last_name,
      email: config.user.email,
    });
  });
};
